
export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },

    options: {
      type: Array,
      required: true,
    },

    rules: {
      type: [String, Object],
      default: '',
    },

    name: {
      type: String,
      required: true,
    },

    label: {
      type: String,
      default: '',
    },

    validationMode: {
      type: String,
      default: 'lazy',
    },

    instructions: {
      type: String,
      default: '',
    },

    getOptionLabel: {
      type: Function,
      default: (option) =>
        typeof option === 'object' && option.label ? option.label : option,
    },

    getOptionValue: {
      type: Function,
      default: (option) =>
        typeof option === 'object' && option.value ? option.value : option,
    },

    flexDirection: {
      type: String,
      default: 'col',
    },
  },

  data() {
    return {
      innerValue: this.value,
    }
  },

  computed: {
    hasCustomLabel() {
      return !!this.$slots.label
    },
  },

  watch: {
    innerValue(innerValue) {
      this.$emit('input', innerValue)
    },

    value(value) {
      this.innerValue = value
    },
  },
}
